export default "__VITE_ASSET__DK8Ep89d__"